import { SelectProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useSWRImmutable from 'swr/immutable';

import { AsyncSelect } from '~components';

import ItemCategory from '../../interfaces/itemCategory';
import ItemCategoryService from '../../services/itemCategoryService';

type ItemCategorySelectProps = {
	value?: ItemCategory | null;
} & SelectProps;

const service = new ItemCategoryService();

const ItemCategorySelect = ({
	// label = i18n.t('ui.label.category'),
	value = null,
	...props
}: ItemCategorySelectProps) => {
	const { t } = useTranslation();

	const { data, isLoading } = useSWRImmutable(service.basePath, () => service.getCategories());

	return (
		<AsyncSelect
			{...props}
			clearable
			emptyLabel={t('allResources', { resource: t('categories') })}
			// label={label}
			loading={isLoading}
			value={value}
			options={data ?? []}
		/>
	);
};

export default ItemCategorySelect;
